module.exports = __webpack_public_path__ + "img/qr_gchrd.a1e70866.png";